$(document).ready(function () {
    let CSPslidetext = $('.csp-slide-text');
  
    function getNextslide() {
        let activeSlide = $('.active');
        let nextCSPslide;

        if (activeSlide.next().length - 1) {
            nextCSPslide = activeSlide.next().find('h1').html();
        } else {
            nextCSPslide = $('.carousel-item').find('h1').html();
        }
        CSPslidetext.html(nextCSPslide);
    } 
    getNextslide();

    $('.carousel-springs').on('slid.bs.carousel', function () {
        getNextslide();
    });
});
